import { render, staticRenderFns } from "./Ui.vue?vue&type=template&id=44bb76c8&scoped=true&lang=pug&"
import script from "./Ui.vue?vue&type=script&lang=js&"
export * from "./Ui.vue?vue&type=script&lang=js&"
import style0 from "./Ui.vue?vue&type=style&index=0&id=44bb76c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb76c8",
  null
  
)

export default component.exports